'use client'

import { DialogTitle } from '@headlessui/react'
import type { ReactNode } from 'react'
import type { TestIds } from '../../../../utils/testing.ts'
import { Heading } from '../../../heading/heading.tsx'

export type ModalCenteredHeaderTitleProps = TestIds & {
  children: ReactNode
}

export const ModalCenteredHeaderTitle = ({
  children,
  ...testIds
}: ModalCenteredHeaderTitleProps) => {
  return (
    <DialogTitle as={Heading} fontSize="4xl" {...testIds}>
      {children}
    </DialogTitle>
  )
}
